function getPrimaryTableOffset(): number {
  return document.getElementById('primaryTable')?.getBoundingClientRect().top ?? 0;
}

// TODO (S.Panfilov) any
function getIframeOffset(iframeSection: any, iframeSrcUrl: string): number {
  const hasHeadingWithinSection = iframeSection.querySelectorAll('heading > h2').length > 0;
  const iframeOffsetTop = iframeSection.querySelectorAll(`[src='${iframeSrcUrl}']`)[0].offsetTop;
  return hasHeadingWithinSection ? iframeOffsetTop : iframeSection.offsetTop + iframeOffsetTop;
}

function getTotalTableOffset(iframeUrlUpdateCB: (url: string) => void): number | undefined {
  // within iframe
  let totalOffset: number | undefined = getPrimaryTableOffset();
  // external to iframe
  const sectionNodeList = window.parent.document.querySelectorAll("[data-component-type='iframe']");
  if (sectionNodeList.length > 0) {
    const sectionList = [].slice.call(sectionNodeList);
    // TODO (S.Panfilov) any
    const filteredSectionList = sectionList.filter((ele: any) => ele.getElementsByTagName('iframe').length > 0);
    // section has one or more iframe elements
    if (filteredSectionList.length > 0) {
      const iframeSrcUrl = window.location.href;
      iframeUrlUpdateCB(iframeSrcUrl);
      // TODO (S.Panfilov) any
      const filteredIframeSectionList = filteredSectionList.filter((section: any) => section.querySelectorAll(`[src='${iframeSrcUrl}']`).length > 0);
      // should be exactly 1, else we have a problem as our table is iframed more than once on the page
      if (filteredIframeSectionList.length === 1) {
        totalOffset += getIframeOffset(filteredIframeSectionList[0], iframeSrcUrl) ?? 0;
      } else {
        totalOffset = undefined;
      }
    } else {
      totalOffset = undefined;
    }
  }
  return totalOffset;
}

export function showSecondaryHeader(iframeUrlUpdateCB: (url: string) => void): void {
  const windowPageYOffset = window.parent.pageYOffset;
  const primaryTable = document.getElementById('primaryTable');
  if (!primaryTable) throw new Error('cannot find primaryTable');
  const secondaryTable = document.getElementById('secondaryTable');
  if (!secondaryTable) throw new Error('cannot find secondaryTable');
  const startOfTable = getTotalTableOffset(iframeUrlUpdateCB);
  if (!startOfTable) throw new Error('cannot find startOfTable');
  const endOfTable = startOfTable + primaryTable.offsetHeight;
  let topNum = 0;
  if (windowPageYOffset > startOfTable && windowPageYOffset <= endOfTable) {
    // eslint-disable-next-line functional/immutable-data
    secondaryTable.style.width = window.getComputedStyle(primaryTable).width;
    if (startOfTable !== getPrimaryTableOffset()) {
      topNum = windowPageYOffset - startOfTable + getPrimaryTableOffset();
    }
    // eslint-disable-next-line functional/immutable-data
    secondaryTable.style.top = `${topNum}px`;
    secondaryTable.classList.remove('d-none');
  } else {
    secondaryTable.classList.add('d-none');
  }
}
